const $inject = ['$http', '$q', '$filter', '$rootScope', 'moment', 'apiService', 'cartService', 'changeCartService', 'settingsService', 'travelFiltersService'];

const travelService = function travelService($http, $q, $filter, $rootScope, moment, apiService, cartService, changeCartService, settingsService, travelFiltersService) {
  let service = {
    resultsMaster: [],
    results: [],
    economyClasses: [],
    fareClasses: [],
    hasResults: false,
    init: init,
    getResults: getResults,
    getSeatMap: getSeatMap,
    computeSearches: computeSearches,
    getFlightInfo: getFlightInfo,
    getTravelDetail: getTravelDetail,
    getFareRules: getFareRules,
    prepData: prepData,
    addFilter: addFilter,
    addFilters: addFilters,
    updateFilters: updateFilters,
    removeFilter: removeFilter,
    process: process,
    sort: sort,
    itemAddedToCart: itemAddedToCart
  };

  $rootScope.$on('cartService:rail:removed', service.checkFareFilters);

  function init() {
    service.resultsMaster = [];
    service.results = [];
    service.economyClasses = [];
    service.fareClasses = [];
    service.hasResults = false;
  }


  function getResults(searches, isChanging) {
    let searchRequest = _.clone(searches);
    const apiConfig = window.svelteStore.apiConfig('travelSearch');

    _.forEach(searchRequest, (search) => {
      search.PaxCount = search.Passengers.length;
      search.Searches = [{
        Identifier: search.Identifier,
        Type: 'Flight'
      }];
    });

    $http['post'](apiConfig.url, searchRequest, {
      errorMessage: 'searching for travel',
      apiVersion: apiConfig.version
    })
    .then(res => {
      const data = res.data;

      _.forEach(data, (result, resultIndex) => {
        service.results[resultIndex] = prepData(result, resultIndex, data.length, isChanging);
      });

      service.resultsMaster = $filter('deepCopyFilter')(service.results);

      service.hasResults = true;
    });
  }

  function getSeatMap(flights) {
    const deferred = $q.defer();
    const apiUrl = apiService.getUrl('travelSeatMap');

    $http.post(apiUrl, { SeatMapSearches: flights }, { apiVersion: 21 })
    .then((res) => {
      let data = res.data;
      deferred.resolve(data);
    })
    .catch(() => {
      deferred.reject();
    });

    return deferred.promise;
  }

  function getFareClassGroupTypes(flight, from, to, legacyMode) {
    if (legacyMode) {
        const groupTypes = {};

        _.forEach(flight.FareClasses, (fareClass) => {
          if (fareClass) {
            fareClass.Fares.forEach(fare => {
              if (fare && !groupTypes[fare.GroupType]) {
                groupTypes[fare.GroupType] = fare.CabinCode;
              }
            })
          }
        });

        return _.isEmpty(groupTypes) ? undefined : groupTypes;
    } else {
        const groupTypes = [];

        _.forEach(flight.FareClasses, (fareClass) => {
          _.forEach(fareClass.Fares, ({CabinCode, GroupType, ResBookDesignCode, OriginLocationCode, DestinationLocationCode}) => {
            if (from === OriginLocationCode && to === DestinationLocationCode) {
              groupTypes.push({
                CabinCode: CabinCode,
                CabinName: GroupType,
                BookingCode: ResBookDesignCode
              })
            }
          })
        });

        return Array.from(
            new Set(groupTypes.map((item) => JSON.stringify(item))),
            (item) => JSON.parse(item)
        );
    }
  }

  function computeFlightData(gdsProvider, from, to, outboundFlight, inboundFlight, parentFlight, legacyMode) {
    return {
      OriginLocationCode: from,
      DestinationLocationCode: to,
      FlightNumber: outboundFlight.TripNumber,
      CarrierCode: outboundFlight.Carrier,
      OperatingCarrierCode: outboundFlight.OperatingCarrier,
      OperatingCarrierFlightNumber: outboundFlight.OperatingCarrierTripNumber,
      DepartureDateTimeOffset: outboundFlight.DepartureDateTimeOffset,
      ArrivalDateTimeOffset: inboundFlight.DepartureDateTimeOffset,
      GdsProvider: gdsProvider,
      FareClassGroupTypes: getFareClassGroupTypes(parentFlight, from, to, legacyMode)
    };
  }

  function computeSearches({flight, legacyMode}) {
    const searches = [];

    if(flight.Legs.length === 0) {
      searches.push(computeFlightData(flight.GdsProvider, flight.OriginLocationCode, flight.DestinationLocationCode, flight, flight, flight, legacyMode));
    } else {
      searches.push(computeFlightData(flight.GdsProvider, flight.OriginLocationCode, flight.Legs[0].Origin.Code, flight, flight.Legs[0], flight, legacyMode));

      _.forEach(flight.Legs, (leg, legIndex) => {
        if(legIndex === flight.Legs.length - 1) {
          searches.push(computeFlightData(flight.GdsProvider, leg.Origin.Code, flight.DestinationLocationCode, leg, flight, flight, legacyMode));
        } else {
          searches.push(computeFlightData(flight.GdsProvider, leg.Origin.Code, flight.Legs[legIndex + 1].Origin.Code, leg, flight.Legs[legIndex + 1], flight, legacyMode));
        }
      });
    }

    return searches;
  }

  function getTravelDetail(travel) {
    const deferred = $q.defer();

    if (travel.Details.length) {
      deferred.resolve(travel.Details);
    } else {
      const apiUrl = apiService.getUrl('travelDetail', {
        type: travel.Type,
        travelId: travel.Identifier
      });

      const params = {
        searchIdentifier: travel.SearchIdentifier
      };

      $http.get(apiUrl, { params: params })
        .then(res => {
          let data = res.data;
          travel.Details = data;
          deferred.resolve(travel.Details);
        })

        .catch(() => {
          deferred.reject();
        });
    }

    return deferred.promise;
  }

  function getFlightInfo(flight) {
    const deferred = $q.defer();

    if (flight.Information) {
      deferred.resolve(flight.Information);
    } else {
      const apiUrl = apiService.getUrl("flightInformation");

      let searchData = computeSearches({flight, legacyMode: true});

      $http
        .post(apiUrl, {
          FlightInformationSearches: searchData,
        })
        .then((res) => {
          let data = res.data;
          flight.Information = data;
          deferred.resolve(flight.Details);
        })

        .catch(() => {
          deferred.reject();
        });
    }

    return deferred.promise;
  }


  function getFareRules(sector, fare) {
    const deferred = $q.defer();

    if (fare.RemarksCollection) {
      const fareRuleData = () => {
        let text = '';
        _.forEach(fare.RemarksCollection, (obj) => {
          text = text + obj.Code + '\n' + obj.Value + '\n\n';
        });
        return text;
      };

      const fareRules = {
        Type: 'Text',
        Data: fareRuleData()
      };

      deferred.resolve(fareRules);
    } else {
      const apiUrl = apiService.getUrl('travelFareRules', {
        type: sector.Type,
        travelId: sector.Identifier,
        fareId: fare.Identifier
      });

      const params = {
        searchIdentifier: sector.SearchIdentifier
      };

      $http.get(apiUrl, { params: params })
        .then(res => {
          let data = res.data;
          deferred.resolve(data);
        })

        .catch(() => {
          deferred.reject();
        });
    }

    return deferred.promise;
  }


  function prepData(data, index, totalSets, isChanging) {
    let obj = {
      selected: false,
      matchingResultsIndex: data.MatchingResultsIndex,
      searchDate: data.Date,
      destination: data.Destination,
      origin: data.Origin,
      searchResults: data.Results,
      classes: [],
      activeSort: null,
      resultLimitIncrement: 20,
      resultLimit: getResultLimit(totalSets),
      resultsFilters: {
        filters: travelFiltersService.getFilters(),
        searchFilterTotal: 0
      }
    };

    _.forEach(data.Results, (item) => {
      let fareClasses = item.FareClasses;

      item.$state = {};
      item.TotalFares = 0;
      item.SupplierName = item.SupplierName || item.CarrierName;
      item.ReturnPricing = _.isInteger(obj.matchingResultsIndex);

      // TODO move to a filter
      if(item.Rating) {
        item.Rating.OnTimeLevel = item.Rating.OntimePercent < 0.7 ? 'low' : item.Rating.OntimePercent < 0.9 ? 'mid' : 'high';
      }

      angular.forEach(fareClasses, (fare, key) => {
        if (fare === null) {
          return delete fareClasses[key];
        }

        fare.$state = {};
        fare.Class = key;

        const defaultFare = _.omit(fare, 'AdditionalFares');

        fare.AdditionalFares.unshift(defaultFare);

        fare.AdditionalFares = _.map(fare.AdditionalFares, (additionalFare) => {
          additionalFare.$state = {};
          additionalFare.FareCode = additionalFare.FareCode || additionalFare.FareName;
          additionalFare.MatchingResultsIndex = data.MatchingResultsIndex;
          additionalFare.Class = key;

          return additionalFare;
        });

        if(fare.GroupType === 'Economy') {
          if(!service.economyClasses.includes(fare.Class)) {
            service.economyClasses.push(fare.Class);
          }
        }

        item.TotalFares += fare.AdditionalFares.length;
      });

      obj.classes = obj.classes.concat(Object.keys(fareClasses));

      let priceFilterSettings = obj.resultsFilters.filters.priceRange.settings;

      if (item.MaxRate > priceFilterSettings.maxValue) {
        const roundedMaxRate = Math.ceil(item.MaxRate);
        priceFilterSettings.maxValue = roundedMaxRate;
        priceFilterSettings.defaultMax = roundedMaxRate;
      }
    });

    obj.resultsFilters.filters.carrier.settings.options = getCarrierOptions(data.Results);

    let maxRate = getMaxRate(data.Results);
    obj.resultsFilters.filters.priceRange.settings.defaultMax = maxRate;
    obj.resultsFilters.filters.priceRange.settings.maxValue = maxRate;

    obj.resultsFilters.filters.cartItems.settings.resultsIndex = index;
    obj.resultsFilters.filters.cartItems.settings.matchingResultsIndex = data.MatchingResultsIndex;

    if(isChanging) {
      obj.resultsFilters.filters.cartItems.settings.cartItems = changeCartService.items;
    }

    buildFareClasses(obj.classes);

    obj.classes = service.fareClasses;
    return obj;
  }

  function getResultLimit(totalSets) {
    const MAX_TOTAL = 100;

    return totalSets === 3 ? 30 : MAX_TOTAL / totalSets;
  }

  function getMaxRate(results) {
    return _.reduce(results, (maxRate, result) => {
      return Math.ceil(result.MaxRate > maxRate ? result.MaxRate : maxRate);
    }, 0);
  }

  function getCarrierOptions(results) {
    const uniqueResults = _.uniqBy(results, (item) => {
      return item.Carrier;
    });

    const orderedResults = _.orderBy(uniqueResults, (item) => {
      return item.CarrierName.toLowerCase();
    });

    return _.map(orderedResults, (item) => {
      return {
        value: item.Carrier,
        label: item.CarrierName,
        id: `Carrier-${item.Carrier}`
      };
    });
  }

  function orderFareClasses(fareClasses) {
    const fareBucketClasses = settingsService.settings.FlightConfiguration.FareBucketClasses;

    if(!fareBucketClasses) {
      return fareClasses;
    }

    return _.orderBy(fareClasses, (fareClass) => {
      const fareBucketClassSettings = _.find(fareBucketClasses, (bucketClass) => {
        return bucketClass.Name === fareClass;
      });

      return fareBucketClassSettings ? fareBucketClassSettings.Sort : Number.MAX_SAFE_INTEGER;
    });
  }

  function buildFareClasses(classes) {
    service.fareClasses = service.fareClasses.concat(classes);
    service.fareClasses = _.uniq(service.fareClasses);
    service.fareClasses = orderFareClasses(service.fareClasses);

    angular.forEach(service.results, (result) => {
      result.classes = service.fareClasses;
    });
  }

  function addFilters(filters, index, clear) {
    if(clear) {
      service.results[index].resultsFilters.filters = {};
    }

    _.forOwn(filters, (filter, key) => {
      service.results[index].resultsFilters.filters[key] = filter;
    });

    process(index);
  }

  function updateFilters(filters, index, clear) {
    if(clear) {
      service.results[index].resultsFilters.filters = {};
    }

    _.forOwn(filters, (filter, key) => {
      service.results[index].resultsFilters.filters[key] = filter;
    });

    process(index);
  }

  function clearFilters(index) {
    service.results[index].selected = false;

    _.forOwn(service.results[index].resultsFilters.filters, (filter) => {
      if(_.isFunction(filter.settings.clear)) {
        filter.settings.clear();
      }
    });
  }

  function addFilter(filter, index, clear) {
    if(clear) {
      clearFilters(index);
    }

    if(filter) {
      service.results[index].resultsFilters.filters[filter.name] = filter;
    }

    process(index);
  }

  function removeFilter(filterName, index) {
    delete service.results[index].resultsFilters.filters[filterName];

    process(index);
  }

  function sort(sortOption, index) {
    service.results[index].activeSort = sortOption;
    process(index);
  }

  function process(index) {
    if (index === null) return;

    let resultsSet = service.results[index];
    let processedResults = _.clone(service.resultsMaster[index].searchResults);
    let clearActiveFilters = false;

    resultsSet.resultsFilters.searchFilterTotal = 0;

    _.forOwn(resultsSet.resultsFilters.filters, (filter) => {
      if(filter.settings.isActive()) {
        if(filter.clearActiveFilters) {
          clearActiveFilters = true;
        }

        if(clearActiveFilters && _.isFunction(filter.settings.clear)) {
          filter.settings.clear();
        } else {
          if(filter.isResultsFilter) {
            resultsSet.resultsFilters.searchFilterTotal += 1;
          }

          processedResults = $filter(filter.filterName)(processedResults, filter.settings);
        }
      }
    });

    if(resultsSet.activeSort) {
      processedResults = _.orderBy(processedResults, (result) => {
        if (resultsSet.activeSort.sortField === 'MinCarbonEmissionAmount') {
          let carbonEmissions = Object.values(result.FareClasses).map(fare => fare.CarbonEmissionAmount);
          return Math.min(...carbonEmissions);
        } else {
          return result[resultsSet.activeSort.sortField];
        }
      });

      if(resultsSet.activeSort.isReverse) {
        processedResults = processedResults.reverse();
      }
    }

    resultsSet.searchResults = processedResults;
    $rootScope.$broadcast('flightDataProcessed');
  }

  function itemAddedToCart(parentIndex, result, fare, isChanging) {
    const resultsSet = service.results[parentIndex];
    resultsSet.selected = true;

    if(isChanging) {
      changeCartService.addChange(parentIndex, result, fare);
    } else {
      cartService.items.push({
        type: 'flight',
        fare,
        result,
        orderBy: parentIndex,
        matchingIndex: resultsSet.matchingResultsIndex,
      });
    }

    process(parentIndex);

    if(_.isInteger(resultsSet.matchingResultsIndex)) {
      process(resultsSet.matchingResultsIndex);
    }
  }

  return service;
};


travelService.$inject = $inject;

export default travelService;




// WEBPACK FOOTER //
// ./src/services/travelService.js